<div [class.loader-hidden]="!show">
    <div class="loader-overlay">
            <div *ngIf="show">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
    </div>
</div>
